// extracted by css-extract-rspack-plugin
var _1 = "loading-filter-value-cCBa5P";
var _2 = "loading-filter-value-cCBa5P";
export { _1 as "loading-filter-value", _2 as "loadingFilterValue" }
